<template>
  <div class="custom_input_container">
    <label class="w-100 text-capitalize">{{ label }}</label>
    <div class="input_wrapper">
      <div
        v-if="withoutIcon"
        class="icon_wrapper"
        :class="{ resize_height: isTextarea }"
      >
        <!-- <img src="@/assets/images/person.png" alt="person" /> -->
        <font-awesome-icon
          class="app_input_icon"
          v-if="whichIconName == 'email'"
          icon="fa-solid fa-envelope"
        />
        <font-awesome-icon
          class="app_input_icon"
          v-else-if="whichIconName == 'password'"
          icon="fa-solid fa-lock"
        />
        <font-awesome-icon
          class="app_input_icon"
          v-else-if="whichIconName == 'phone'"
          icon="fa-solid fa-phone-alt"
        />
        <font-awesome-icon
          class="app_input_icon"
          v-else-if="whichIconName == 'location'"
          icon="fa-solid fa-map-marker-alt"
        />
        <font-awesome-icon
          v-else
          class="app_input_icon"
          icon="fa-solid fa-user"
        />
      </div>
      <span v-if="isPhone" class="is_phone">+971</span>
      <input
        v-if="!isTextarea"
        v-model="model"
        :type="type"
        :placeholder="placeholder"
        :class="{ is_phone_num: isPhone }"
      />
      <font-awesome-icon
        v-if="whichIconName == 'password'"
        class="app_input_icon"
        icon="fa-solid fa-eye"
        role="button"
        @click="showPassword"
      />
      <textarea
        v-if="isTextarea"
        v-model="model"
        :type="type"
        :placeholder="placeholder"
        class="form_text_area"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppInput",
  props: {
    label: {
      type: String,
    },
    isLabel: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    inputvalue: {
      type: [String, Number],
      default: "",
    },
    isTextarea: {
      type: Boolean,
      default: false,
    },
    isPassword: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withoutIcon: {
      type: Boolean,
      default: true,
    },
    whichIconName: {
      type: String,
      default: "user",
    },
    isPhone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.inputvalue,
    };
  },
  watch: {
    model(currentValue) {
      this.$emit("input", currentValue);
    },
  },
  methods: {
    showPassword() {
      this.$emit("show-password");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_input_container {
  // display: flex;
  .input_wrapper {
    display: flex;
    border: 1px solid $border_color;
    border-radius: 6px;
    transition: $transition;
    align-items: center;
    padding: 8px;
    .icon_wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
      &.resize_height {
        height: fit-content;
      }
      img {
        width: 27px;
        height: 27px;
      }
    }

    input,
    textarea {
      color: $text_color;
      flex-grow: 1;

      outline: none;
      border: none;
    }
    &:focus-within {
      border-color: $main_color;
    }
    textarea {
      min-height: 200px;
      resize: none;
    }
  }
  label {
    color: $text_color;
    font-size: 16px;
    margin-bottom: 8px;
  }
  .is_phone_num {
    padding: 0 5px;
  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  ::placeholder {
    opacity: 0.5;
  }
  .app_input_icon {
    color: $text_color;
    width: 20px;
    height: 20px;
  }
  .is_phone {
    color: $text_color;
    border-right: 2px solid $border_color;
    // border-left: 2px solid $border_color;
    // margin: 0 2px;
    padding: 0 3px;
  }
}
</style>
